import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//获取赛事列表
export const matchList = (params) => {
  return axios.get(`${base}/api/Match/GetMatches`, { params: params });
};
//获取比赛列表不分页
export const matchListAll = (params) => {
  return axios.get(`${base}/api/Match/GetMatchesList`, { params: params });
};
//获取赛事详情
export const matchDetail = (params) => {
  return axios.get(`${base}/api/Match/GetMatchById`, { params: params });
};
//新增赛事
export const addMatch = (params) => {
  return axios.post(`${base}/api/Match/AddMatch`, params);
};
//删除赛事
export const deleteMatch = (params) => {
  return axios.delete(`${base}/api/Match/DeleteMatch`, { params: params });
};
//批量删除赛事
export const batchDeleteMatch = (params) => {
  return axios.delete(`${base}/api/Match/DeletesMatches`, { params: params });
};
//修改赛事
export const updateMatch = (params) => {
  return axios.put(`${base}/api/Match/PutMatch`, params);
};
//上传赛事图片
export const uploadMatchImage = (params) => {
  return axios.post(`${base}/api/Match/UploadMatchImage`, params);
};

// 赛事服务标签
export const serviceTagList = (params) => {
  return axios.get(`${base}/api/Match/GetMatchServiceTags`, { params: params });
};
//新增赛事服务标签
export const addServiceTag = (data) => {
  return axios.post(`${base}/api/Match/AddMatchServiceTag`, data);
};
//修改赛事服务标签
export const updateServiceTag = (data) => {
  return axios.put(`${base}/api/Match/PutMatchServiceTag`, data);
};
//删除赛事服务标签
export const deleteServiceTag = (params) => {
  return axios.delete(`${base}/api/Match/DeleteMatchServiceTag`, {
    params: params,
  });
};
//批量删除赛事服务标签
export const batchDeleteServiceTag = (data) => {
  return axios.post(`${base}/api/Match/DeletesMatchServiceTags`, data);
};

//获取赛事场次列表
export const matchSessionList = (params) => {
  return axios.get(`${base}/api/Match/GetMatchSessions`, { params: params });
};

//新增赛事场次
export const addMatchSession = (params) => {
  return axios.post(`${base}/api/Match/AddMatchSession`, params);
};
//修改赛事场次
export const updateMatchSession = (params) => {
  return axios.put(`${base}/api/Match/PutMatchSession`, params);
};
//删除赛事场次
export const deleteMatchSession = (params) => {
  return axios.delete(`${base}/api/Match/DeleteMatchSession`, {
    params: params,
  });
};
//批量删除赛事场次
export const batchDeleteMatchSession = (params) => {
  return axios.post(`${base}/api/Match/DeletesMatchSessions`, params);
};

//票档列表
export const ticketList = (params) => {
  return axios.get(`${base}/api/Match/GetMatchTicketGrade`, { params: params });
};

//新增票档
export const addTicket = (params) => {
  return axios.post(`${base}/api/Match/AddMatchTicketGrade`, params);
};
//修改票档
export const updateTicket = (params) => {
  return axios.put(`${base}/api/Match/PutMatchTicketGrade`, params);
};
//删除票档
export const deleteTicket = (params) => {
  return axios.delete(`${base}/api/Match/DeleteMatchTicketGrade`, {
    params: params,
  });
};
//批量删除票档
export const batchDeleteTicket = (params) => {
  return axios.post(`${base}/api/Match/DeletesMatchTicketGrades`, params);
};

//报名列表
export const matchRegisterList = (params) => {
  return axios.get(`${base}/api/MatchBusiness/GetMatchRegisters`, {
    params: params,
  });
};

//参赛项目
//参赛项目列表
export const productList = (params) => {
  return axios.get(`${base}/api/Match/GetMatchProducts`, { params: params });
};
//新增参赛项目
export const addProduct = (params) => {
  return axios.post(`${base}/api/Match/AddMatchProducts`, params);
};
//删除参赛项目
export const deleteProduct = (params) => {
  return axios.delete(`${base}/api/Match/DeleteMatchProducts`, {
    params: params,
  });
};
//修改参赛项目
export const updateProduct = (params) => {
  return axios.put(`${base}/api/Match/PutMatchProducts`, params);
};
//修改参赛项目上下架状态
export const updateProductIsLaunch = (params) => {
  return axios.post(`${base}/api/Match/PostUpdateIsLaunch`, params);
};

//导出列表
export const PostExportMatchRegisterExcel = (params) => {
  return axios.post(
    `${base}/api/MatchBusiness/PostExportMatchRegisterExcel`,
    params,
    {
      responseType: "blob",
    },
  );
};

//座位管理
//获取座位列表
export const seatList = (params) => {
  return axios.get(`${base}/api/Seat/GetSeats`, { params: params });
};
//新增座位
export const addSeat = (params) => {
  return axios.post(`${base}/api/Seat/AddSeat`, params);
};
//删除座位
export const deleteSeat = (params) => {
  return axios.delete(`${base}/api/Seat/DeleteSeat`, { params: params });
};
//批量删除座位
export const batchDeleteSeats = (params) => {
  return axios.post(`${base}/api/Seat/DeletesSeat`, params);
};
//批量冻结座位
export const batchLockSeats = (params) => {
  return axios.post(`${base}/api/Seat/DongjieSeats`, params);
};
//查看座位详情
export const getSeatDetail = (params) => {
  return axios.get(`${base}/api/Seat/GetSeatsDetail`, { params: params });
};

// 无需登录：获取座位详情（H5 公共接口）
export const getSeatDetailNoPer = (params) => {
  return axios.get(`${base}/api/Seat/GetSeatsDetailNoPer`, { params: params });
};

// 无需登录：提交座位身份信息（H5 公共接口）
export const submitSeatIdentityNoPer = (params) => {
  return axios.post(`${base}/api/Seat/SubmitSeatIdentityNoPer`, params);
};
